import React from "react";
import "../App.css";
import "./AboutSection.css";

function AboutSection() {
  return (
    <section className="about-section" aria-label="About Fenix Media">
      <div className="about-content">
        <h1>
          Meet the Team Behind Fenix Media
        </h1>
      </div>
    </section>
  );
}

export default AboutSection;

